let linkConfig = {
  download: {
    ios: {
      eetrade: "https://apps.apple.com/cn/app/id6465077365",
    },
    androidUrl: {
      eetall: "https://39.108.127.136:6010/source/material/EET_GW.apk",
      eetallBackup: "https://39.108.127.136:6010/source/material/EET_GWBAK.apk", // Backup URL for EET All
      eetrade: "https://39.108.127.136:6010/source/material/EETRADE_GW.apk",
      eetmarkets: [
        "https://mp-074d31c0-761b-4193-8c5c-a4b247ef9811.cdn.bspapp.com/EET Markets/EETMARKETS_GW.apk",
        "https://39.108.127.136:6010/source/material/EETMARKETS_GW.apk",
        "https://39.108.127.136:6010/source/material/EETMARKETS_KF.apk",
      ],
      h5trade: [
        "https://39.108.127.136:6010/source/material/EET_MTRADE.apk",
        "https://downloads.newapknest.com/source/material/EET_MTRADE.apk",
      ],
    },
  },
};

export { linkConfig };
